export const EVENT_PROCEDURES_STEPS_LIBRARY_LIST_ID = "eventProceduresStepsLibraryList";
export const ATTRIBUTES = [
  {
    id: "title",
    title: "Title",
    type: "STRING",
    filterable: false
  },
  {
    id: "type",
    title: "Action",
    type: "STRING"
  }
];
export const listElements = {
  defaultLayout: {
    entityTableId: EVENT_PROCEDURES_STEPS_LIBRARY_LIST_ID,
    defaultPageSize: 10,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: ["title", "type"],
    defaultColumnOrder: ["title", "type"]
  }
};
export const deserializeEventProcedureSteps = ({ page, per_page, total, count, event_procedure_steps }) => ({
  attributes: ATTRIBUTES,
  list: event_procedure_steps.map((step) => {
    var _a, _b;
    return {
      ...step,
      type: (_b = (_a = step == null ? void 0 : step.action) == null ? void 0 : _a.config) == null ? void 0 : _b.type
    };
  }),
  pagination: { total, page, per_page, count }
});
